// Copied directly from viu-schema-data
export const MOCKED_QE_SCHEMAS_FROM_FILE: Record<string, any>[] = [
    {
        "schema_type": "QUOTE_EXPERIENCE_COLORS_CONTENT",
        "schema_type_version": 1,
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience_content/colors.json",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "definitions": {
                "color": {
                    "type": "string",
                    "pattern": "^#(?:[0-9a-fA-F]{3}){1,2}$"
                }
            },
            "title": "QuoteExperienceColorsContent",
            "type": "object",
            "properties": {
                "color": {
                    "type": "object",
                    "properties": {
                        "informativeDark": {
                            "$ref": "#/definitions/color"
                        },
                        "informativeLight": {
                            "$ref": "#/definitions/color"
                        },
                        "informativeMedium": {
                            "$ref": "#/definitions/color"
                        },
                        "negativeDark": {
                            "$ref": "#/definitions/color"
                        },
                        "negativeLight": {
                            "$ref": "#/definitions/color"
                        },
                        "negativeMedium": {
                            "$ref": "#/definitions/color"
                        },
                        "onPrimaryUi": {
                            "$ref": "#/definitions/color"
                        },
                        "positiveDark": {
                            "$ref": "#/definitions/color"
                        },
                        "positiveLight": {
                            "$ref": "#/definitions/color"
                        },
                        "positiveMedium": {
                            "$ref": "#/definitions/color"
                        },
                        "primaryAccent": {
                            "$ref": "#/definitions/color"
                        },
                        "primaryBackground": {
                            "$ref": "#/definitions/color"
                        },
                        "primaryBackgroundHover": {
                            "$ref": "#/definitions/color"
                        },
                        "primaryBackgroundSelected": {
                            "$ref": "#/definitions/color"
                        },
                        "primaryBorder": {
                            "$ref": "#/definitions/color"
                        },
                        "primaryBorderHover": {
                            "$ref": "#/definitions/color"
                        },
                        "primaryText": {
                            "$ref": "#/definitions/color"
                        },
                        "primaryUi": {
                            "$ref": "#/definitions/color"
                        },
                        "primaryUiBackgroundDisabled": {
                            "$ref": "#/definitions/color"
                        },
                        "primaryUiForegroundDisabled": {
                            "$ref": "#/definitions/color"
                        },
                        "primaryUiHover": {
                            "$ref": "#/definitions/color"
                        },
                        "secondaryAccent": {
                            "$ref": "#/definitions/color"
                        },
                        "secondaryBackground": {
                            "$ref": "#/definitions/color"
                        },
                        "secondaryBorder": {
                            "$ref": "#/definitions/color"
                        },
                        "secondaryText": {
                            "$ref": "#/definitions/color"
                        },
                        "secondaryUi": {
                            "$ref": "#/definitions/color"
                        },
                        "tertiaryText": {
                            "$ref": "#/definitions/color"
                        },
                        "warningDark": {
                            "$ref": "#/definitions/color"
                        },
                        "warningLight": {
                            "$ref": "#/definitions/color"
                        },
                        "warningMedium": {
                            "$ref": "#/definitions/color"
                        }
                    },
                    "additionalProperties": false,
                    "required": []
                }
            },
            "additionalProperties": false,
            "required": [
                "color"
            ]
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_TYPOGRAPHY",
        "schema_type_version": 1,
        "filename": "theme.json",
        "filepointer": "/baseTokens/questionnaire/typography",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/typography",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "title": "Typography",
            "type": "object",
            "definitions": {
                "fontWeight": {
                    "type": "number",
                    "min": 100,
                    "max": 900
                },
                "pixelSize": {
                    "type": "string",
                    "pattern": "[0-9]+px"
                },
                "fontFamily": {
                    "type": "string",
                    "enum": [
                        "$questionnaire.typography.fontFamily.primary",
                        "$questionnaire.typography.fontFamily.secondary"
                    ]
                }
            },
            "properties": {
                "fontFamily": {
                    "type": "object",
                    "properties": {
                        "primary": {
                            "type": "string"
                        },
                        "secondary": {
                            "type": "string"
                        }
                    },
                    "required": [
                        "primary",
                        "secondary"
                    ]
                },
                "button": {
                    "type": "object",
                    "properties": {
                        "fontWeight": {
                            "$ref": "#/definitions/fontWeight"
                        },
                        "fontSize": {
                            "$ref": "#/definitions/pixelSize"
                        },
                        "fontFamily": {
                            "$ref": "#/definitions/fontFamily"
                        }
                    }
                },
                "body": {
                    "type": "object",
                    "properties": {
                        "fontFamily": {
                            "$ref": "#/definitions/fontFamily"
                        },
                        "desktop": {
                            "type": "object",
                            "properties": {
                                "fontWeight": {
                                    "$ref": "#/definitions/fontWeight"
                                },
                                "fontWeightBold": {
                                    "$ref": "#/definitions/fontWeight"
                                },
                                "fontWeightItalic": {
                                    "$ref": "#/definitions/fontWeight"
                                }
                            }
                        },
                        "l": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        }
                                    }
                                }
                            }
                        },
                        "m": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                "heading": {
                    "type": "object",
                    "properties": {
                        "xl": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        },
                        "l": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        },
                        "m": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        },
                        "s": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        },
                        "xs": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        },
                        "xxs": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "required": [
                "fontFamily"
            ]
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_COLORS",
        "schema_type_version": 1,
        "filename": "theme.json",
        "filepointer": "/baseTokens/questionnaire/colors",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/colors.json",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "definitions": {
                "color": {
                    "type": "string",
                    "pattern": "^#(?:[0-9a-fA-F]{3}){1,2}$"
                }
            },
            "title": "Colors",
            "type": "object",
            "properties": {
                "informativeDark": {
                    "$ref": "#/definitions/color"
                },
                "informativeLight": {
                    "$ref": "#/definitions/color"
                },
                "informativeMedium": {
                    "$ref": "#/definitions/color"
                },
                "negativeDark": {
                    "$ref": "#/definitions/color"
                },
                "negativeLight": {
                    "$ref": "#/definitions/color"
                },
                "negativeMedium": {
                    "$ref": "#/definitions/color"
                },
                "onPrimaryUi": {
                    "$ref": "#/definitions/color"
                },
                "positiveDark": {
                    "$ref": "#/definitions/color"
                },
                "positiveLight": {
                    "$ref": "#/definitions/color"
                },
                "positiveMedium": {
                    "$ref": "#/definitions/color"
                },
                "primaryAccent": {
                    "$ref": "#/definitions/color"
                },
                "primaryBackground": {
                    "$ref": "#/definitions/color"
                },
                "primaryBackgroundHover": {
                    "$ref": "#/definitions/color"
                },
                "primaryBackgroundSelected": {
                    "$ref": "#/definitions/color"
                },
                "primaryBorder": {
                    "$ref": "#/definitions/color"
                },
                "primaryBorderHover": {
                    "$ref": "#/definitions/color"
                },
                "primaryText": {
                    "$ref": "#/definitions/color"
                },
                "primaryUi": {
                    "$ref": "#/definitions/color"
                },
                "primaryUiBackgroundDisabled": {
                    "$ref": "#/definitions/color"
                },
                "primaryUiForegroundDisabled": {
                    "$ref": "#/definitions/color"
                },
                "primaryUiHover": {
                    "$ref": "#/definitions/color"
                },
                "secondaryAccent": {
                    "$ref": "#/definitions/color"
                },
                "secondaryBackground": {
                    "$ref": "#/definitions/color"
                },
                "secondaryBorder": {
                    "$ref": "#/definitions/color"
                },
                "secondaryText": {
                    "$ref": "#/definitions/color"
                },
                "secondaryUi": {
                    "$ref": "#/definitions/color"
                },
                "tertiaryText": {
                    "$ref": "#/definitions/color"
                },
                "warningDark": {
                    "$ref": "#/definitions/color"
                },
                "warningLight": {
                    "$ref": "#/definitions/color"
                },
                "warningMedium": {
                    "$ref": "#/definitions/color"
                }
            }
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_CONFIG",
        "schema_type_version": 1,
        "filename": "config.json",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/config",
            "$schema": "http://json-schema.org/draft-07/schema#",
            "title": "Config",
            "type": "object",
            "properties": {
                "ICON_PACK": {
                    "type": "string",
                    "enum": [
                        "detailed",
                        "sharp",
                        "soft"
                    ]
                },
                "CTA_CASE": {
                    "type": "string",
                    "enum": [
                        "ALL_CAPS",
                        "TITLE_CASE"
                    ]
                },
                "PHONE_MASK": {
                    "type": "string"
                },
                "PHONE_NUMBER": {
                    "type": "string"
                },
                "SUPPORTED_INSURANCE_LINES": {
                    "type": "object",
                    "properties": {
                        "CONDOMINIUM": {
                            "type": "boolean"
                        },
                        "LANDLORD": {
                            "type": "boolean"
                        },
                        "LIFE": {
                            "type": "boolean"
                        },
                        "MOTORCYCLE": {
                            "type": "boolean"
                        },
                        "PERSONAL_AUTO": {
                            "type": "boolean"
                        },
                        "PERSONAL_HOME": {
                            "type": "boolean"
                        },
                        "PET": {
                            "type": "boolean"
                        },
                        "RENTERS": {
                            "type": "boolean"
                        }
                    }
                }
            }
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_LOCALIZATIONS",
        "schema_type_version": 1,
        "filename": "localizations.json",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/localizations",
            "$schema": "http://json-schema.org/draft-07/schema#",
            "title": "Localizations",
            "type": "object",
            "properties": {
                "molecules": {
                    "type": "object",
                    "properties": {
                        "confirmEmailModal": {
                            "type": "object",
                            "properties": {
                                "animationName": {
                                    "type": "string"
                                }
                            }
                        },
                        "policyCompareCard": {
                            "type": "object",
                            "properties": {
                                "autoQuoteSummary": {
                                    "type": "object",
                                    "properties": {
                                        "subtitle": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        },
                        "privacyDisclaimer": {
                            "type": "object",
                            "properties": {
                                "partnerPretext": {
                                    "type": "string"
                                }
                            }
                        },
                        "quoteDetailModal": {
                            "type": "object",
                            "properties": {
                                "MOTORCYCLE": {
                                    "type": "object",
                                    "properties": {
                                        "subtitle": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "PERSONAL_AUTO": {
                                    "type": "object",
                                    "properties": {
                                        "subtitle": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "PERSONAL_HOME": {
                                    "type": "object",
                                    "properties": {
                                        "deductibleSubtitle": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                "organisms": {
                    "type": "object",
                    "properties": {
                        "complexModal": {
                            "type": "object",
                            "properties": {
                                "scenarios": {
                                    "type": "object",
                                    "properties": {
                                        "addressNotFound": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "codeNotSupported": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "subtitle": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "insuranceCanBeTricky": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "subtitle": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "insuranceCanBeTrickyLocalAgent": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "lifeCaseOverMaxDoB": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "lifeCaseUnderMinDoB": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "mostAccurateQuotes": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "noQuotesReturned": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "subtitle": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "noQuotesReturnedByOtherInsuranceLine": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "ctaMessage": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "trickyCaseConnectViaPhone": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        "partnerLoadingScreen": {
                            "type": "object",
                            "properties": {
                                "prefill": {
                                    "type": "object",
                                    "properties": {
                                        "PERSONAL_AUTO": {
                                            "type": "object",
                                            "properties": {
                                                "subtitle": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "subtitleMobile": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "PROPERTY": {
                                            "type": "object",
                                            "properties": {
                                                "subtitle": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "subtitleMobile": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        }
                                    }
                                },
                                "quotesLoading": {
                                    "type": "object",
                                    "properties": {
                                        "COMMON": {
                                            "type": "object",
                                            "properties": {
                                                "bottomTitle": {
                                                    "type": "string"
                                                },
                                                "nextStepsCardData": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "object",
                                                        "properties": {
                                                            "id": {
                                                                "type": "string"
                                                            },
                                                            "subText": {
                                                                "type": "string"
                                                            },
                                                            "titleText": {
                                                                "type": "string"
                                                            }
                                                        }
                                                    }
                                                },
                                                "subtitle": {
                                                    "type": "array",
                                                    "items": {
                                                        "type": "string"
                                                    }
                                                },
                                                "subtitleMobile": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                "routes": {
                    "type": "object",
                    "properties": {
                        "errorScreen": {
                            "type": "object",
                            "properties": {
                                "animationName": {
                                    "type": "string"
                                },
                                "subtitleFirst": {
                                    "type": "string"
                                }
                            }
                        },
                        "finalizeContactScreen": {
                            "type": "object",
                            "properties": {
                                "animationName": {
                                    "type": "string"
                                },
                                "subtitle": {
                                    "type": "string"
                                }
                            }
                        },
                        "finalizePolicyScreen": {
                            "type": "object",
                            "properties": {
                                "title": {
                                    "type": "string"
                                }
                            }
                        },
                        "insuranceTypeSelection": {
                            "type": "object",
                            "properties": {
                                "chatWithAgentText": {
                                    "type": "string"
                                },
                                "partnerDisclaimerContent": {
                                    "type": "string"
                                }
                            }
                        },
                        "policyCompareScreen": {
                            "type": "object",
                            "properties": {
                                "additionalCarriersSubtitle": {
                                    "type": "string"
                                },
                                "DEFAULT": {
                                    "type": "object",
                                    "properties": {
                                        "returnedQuotesSubtitle": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "noQuotesReturnedSubtitle": {
                                    "type": "string"
                                }
                            }
                        }
                    }
                },
                "templates": {
                    "type": "object",
                    "properties": {
                        "addressInfoScreen": {
                            "type": "object",
                            "properties": {
                                "disclaimerText": {
                                    "type": "string"
                                }
                            }
                        },
                        "insuranceStartScreen": {
                            "type": "object",
                            "properties": {
                                "disclaimer": {
                                    "type": "string"
                                }
                            }
                        },
                        "optionCardsContainerScreen": {
                            "type": "object",
                            "properties": {
                                "cohabitation": {
                                    "type": "object",
                                    "properties": {
                                        "disclaimerText": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "discounts": {
                                    "type": "object",
                                    "properties": {
                                        "disclaimerText": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        },
                        "partnerFinalizeSuccess": {
                            "type": "object",
                            "properties": {
                                "callUs": {
                                    "type": "array",
                                    "items": {
                                        "type": "string"
                                    }
                                },
                                "disclaimerSubtitle": {
                                    "type": "string"
                                },
                                "disclaimerTitle": {
                                    "type": "string"
                                },
                                "infoLinkText": {
                                    "type": "string"
                                },
                                "policyConsent": {
                                    "type": "string"
                                },
                                "title": {
                                    "type": "string"
                                },
                                "titleOutsideHours": {
                                    "type": "string"
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_ICONS",
        "schema_type_version": 1,
        "filename": "theme.json",
        "filepointer": "/baseTokens/questionnaire/icons",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/icons",
            "$schema": "http://json-schema.org/draft-07/schema#",
            "title": "Icons",
            "type": "object",
            "properties": {
                "discounts": {
                    "type": "object",
                    "properties": {
                        "burglarAlarm": {
                            "type": "string"
                        },
                        "cat": {
                            "type": "string"
                        },
                        "deadBoltLocks": {
                            "type": "string"
                        },
                        "dog": {
                            "type": "string"
                        },
                        "fireExtinguisher": {
                            "type": "string"
                        },
                        "gatedOrLimited": {
                            "type": "string"
                        },
                        "kids": {
                            "type": "string"
                        },
                        "partnerSpouse": {
                            "type": "string"
                        },
                        "roommates": {
                            "type": "string"
                        },
                        "smokeDetector": {
                            "type": "string"
                        },
                        "sprinklerSystem": {
                            "type": "string"
                        }
                    }
                },
                "products": {
                    "type": "object",
                    "properties": {
                        "CONDOMINIUM": {
                            "type": "string"
                        },
                        "LANDLORD": {
                            "type": "string"
                        },
                        "MOTORCYCLE": {
                            "type": "string"
                        },
                        "PERSONAL_AUTO": {
                            "type": "string"
                        },
                        "PERSONAL_HOME": {
                            "type": "string"
                        },
                        "RENTERS": {
                            "type": "string"
                        },
                        "PET": {
                            "type": "string"
                        },
                        "LIFE": {
                            "type": "string"
                        }
                    }
                }
            }
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_CONFIG",
        "schema_type_version": 2,
        "filename": "config.json",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/config",
            "$schema": "http://json-schema.org/draft-07/schema#",
            "title": "Config",
            "type": "object",
            "properties": {
                "ICON_PACK": {
                    "type": "string",
                    "enum": [
                        "detailed",
                        "sharp",
                        "soft"
                    ]
                },
                "CTA_CASE": {
                    "type": "string",
                    "enum": [
                        "ALL_CAPS",
                        "TITLE_CASE"
                    ]
                },
                "PHONE_MASK": {
                    "type": "string"
                },
                "PHONE_NUMBER": {
                    "type": "string"
                },
                "SUPPORTED_INSURANCE_LINES": {
                    "type": "object",
                    "properties": {
                        "CONDOMINIUM": {
                            "type": "boolean",
                            "default": true
                        },
                        "LANDLORD": {
                            "type": "boolean",
                            "default": true
                        },
                        "LIFE": {
                            "type": "boolean",
                            "default": false
                        },
                        "MOTORCYCLE": {
                            "type": "boolean",
                            "default": true
                        },
                        "PERSONAL_AUTO": {
                            "type": "boolean",
                            "default": true
                        },
                        "PERSONAL_HOME": {
                            "type": "boolean",
                            "default": true
                        },
                        "PET": {
                            "type": "boolean",
                            "default": false
                        },
                        "RENTERS": {
                            "type": "boolean",
                            "default": true
                        }
                    }
                }
            },
            "required": [
                "SUPPORTED_INSURANCE_LINES"
            ]
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_CONFIG",
        "schema_type_version": 3,
        "filename": "config.json",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/config",
            "$schema": "http://json-schema.org/draft-07/schema#",
            "title": "Config",
            "type": "object",
            "properties": {
                "ICON_PACK": {
                    "type": "string",
                    "enum": [
                        "detailed",
                        "sharp",
                        "soft",
                        "custom"
                    ]
                },
                "CTA_CASE": {
                    "type": "string",
                    "enum": [
                        "ALL_CAPS",
                        "TITLE_CASE"
                    ]
                },
                "PHONE_MASK": {
                    "type": "string"
                },
                "PHONE_NUMBER": {
                    "type": "string"
                },
                "SUPPORTED_INSURANCE_LINES": {
                    "type": "object",
                    "properties": {
                        "CONDOMINIUM": {
                            "type": "boolean",
                            "default": true
                        },
                        "LANDLORD": {
                            "type": "boolean",
                            "default": true
                        },
                        "LIFE": {
                            "type": "boolean",
                            "default": false
                        },
                        "MOTORCYCLE": {
                            "type": "boolean",
                            "default": true
                        },
                        "PERSONAL_AUTO": {
                            "type": "boolean",
                            "default": true
                        },
                        "PERSONAL_HOME": {
                            "type": "boolean",
                            "default": true
                        },
                        "PET": {
                            "type": "boolean",
                            "default": false
                        },
                        "RENTERS": {
                            "type": "boolean",
                            "default": true
                        }
                    }
                }
            },
            "required": [
                "SUPPORTED_INSURANCE_LINES",
                "ICON_PACK"
            ]
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_CONFIG",
        "schema_type_version": 4,
        "filename": "config.json",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/config",
            "$schema": "http://json-schema.org/draft-07/schema#",
            "title": "Config",
            "type": "object",
            "properties": {
                "EXPERIENCE_TYPE": {
                    "type": "string",
                    "enum": [
                        "cobrand",
                        "private-label",
                        "standard"
                    ],
                    "default": "standard"
                },
                "ICON_PACK": {
                    "type": "string",
                    "enum": [
                        "detailed",
                        "sharp",
                        "soft",
                        "custom"
                    ]
                },
                "CTA_CASE": {
                    "type": "string",
                    "enum": [
                        "ALL_CAPS",
                        "TITLE_CASE"
                    ]
                },
                "PHONE_MASK": {
                    "type": "string"
                },
                "PHONE_NUMBER": {
                    "type": "string"
                },
                "SUPPORTED_INSURANCE_LINES": {
                    "type": "object",
                    "properties": {
                        "CONDOMINIUM": {
                            "type": "boolean",
                            "default": true
                        },
                        "LANDLORD": {
                            "type": "boolean",
                            "default": true
                        },
                        "LIFE": {
                            "type": "boolean",
                            "default": false
                        },
                        "MOTORCYCLE": {
                            "type": "boolean",
                            "default": true
                        },
                        "PERSONAL_AUTO": {
                            "type": "boolean",
                            "default": true
                        },
                        "PERSONAL_HOME": {
                            "type": "boolean",
                            "default": true
                        },
                        "PET": {
                            "type": "boolean",
                            "default": false
                        },
                        "RENTERS": {
                            "type": "boolean",
                            "default": true
                        }
                    }
                }
            },
            "required": [
                "SUPPORTED_INSURANCE_LINES",
                "ICON_PACK",
                "EXPERIENCE_TYPE"
            ]
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_IMAGES",
        "schema_type_version": 1,
        "filename": "theme.json",
        "filepointer": "/baseTokens/questionnaire/images",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/images",
            "$schema": "http://json-schema.org/draft-07/schema#",
            "title": "Images",
            "type": "object",
            "properties": {
                "addressInfoScreen": {
                    "type": "object",
                    "properties": {
                        "MOTORCYCLE": {
                            "type": "object",
                            "properties": {
                                "hero": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        },
                        "PERSONAL_AUTO": {
                            "type": "object",
                            "properties": {
                                "hero": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        },
                        "PROPERTY": {
                            "type": "object",
                            "properties": {
                                "hero": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        }
                    }
                },
                "addVehicleScreen": {
                    "type": "object",
                    "properties": {
                        "MOTORCYCLE": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        },
                        "PERSONAL_AUTO": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        }
                    }
                },
                "complexCaseModal": {
                    "type": "object",
                    "properties": {
                        "noQuotesReturned": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        },
                        "noQuotesReturnedByOtherInsuranceLine": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        },
                        "noQuotesReturnedOnDigitalBindReview": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        }
                    }
                },
                "confirmEmailModal": {
                    "type": "object",
                    "properties": {
                        "formHeader": {
                            "type": "string"
                        }
                    }
                },
                "enterVinModal": {
                    "type": "object",
                    "properties": {
                        "MOTORCYCLE": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        },
                        "PERSONAL_AUTO": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        }
                    }
                },
                "insuranceTypeSelection": {
                    "type": "object",
                    "properties": {
                        "formHeader": {
                            "type": "string"
                        }
                    }
                },
                "partnerFinalizeSuccess": {
                    "type": "object",
                    "properties": {
                        "MOTORCYCLE": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        },
                        "PERSONAL_AUTO": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        },
                        "PROPERTY": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_LOCALIZATIONS",
        "schema_type_version": 2,
        "filename": "localizations.json",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/localizations",
            "$schema": "http://json-schema.org/draft-07/schema#",
            "title": "Localizations",
            "type": "object",
            "properties": {
                "molecules": {
                    "type": "object",
                    "properties": {
                        "confirmEmailModal": {
                            "type": "object",
                            "properties": {
                                "animationName": {
                                    "type": "string"
                                }
                            }
                        },
                        "policyCompareCard": {
                            "type": "object",
                            "properties": {
                                "autoQuoteSummary": {
                                    "type": "object",
                                    "properties": {
                                        "subtitle": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        },
                        "privacyDisclaimer": {
                            "type": "object",
                            "properties": {
                                "partnerPretext": {
                                    "type": "string"
                                },
                                "partnerPosttext": {
                                    "type": "string"
                                },
                                "partnerPrivacy": {
                                    "type": "string"
                                },
                                "partnerPrivacyLink": {
                                    "type": "string"
                                },
                                "privacy": {
                                    "type": "string"
                                },
                                "terms": {
                                    "type": "string"
                                },
                                "text1": {
                                    "type": "string"
                                },
                                "text2": {
                                    "type": "string"
                                },
                                "text3": {
                                    "type": "string"
                                }
                            }
                        },
                        "quoteDetailModal": {
                            "type": "object",
                            "properties": {
                                "MOTORCYCLE": {
                                    "type": "object",
                                    "properties": {
                                        "subtitle": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "PERSONAL_AUTO": {
                                    "type": "object",
                                    "properties": {
                                        "subtitle": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "PERSONAL_HOME": {
                                    "type": "object",
                                    "properties": {
                                        "deductibleSubtitle": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                "organisms": {
                    "type": "object",
                    "properties": {
                        "complexModal": {
                            "type": "object",
                            "properties": {
                                "scenarios": {
                                    "type": "object",
                                    "properties": {
                                        "addressNotFound": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "codeNotSupported": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "subtitle": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "insuranceCanBeTricky": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "subtitle": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "insuranceCanBeTrickyLocalAgent": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "lifeCaseOverMaxDoB": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "lifeCaseUnderMinDoB": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "mostAccurateQuotes": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "noQuotesReturned": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "subtitle": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "noQuotesReturnedByOtherInsuranceLine": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "ctaMessage": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "trickyCaseConnectViaPhone": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        "partnerLoadingScreen": {
                            "type": "object",
                            "properties": {
                                "prefill": {
                                    "type": "object",
                                    "properties": {
                                        "PERSONAL_AUTO": {
                                            "type": "object",
                                            "properties": {
                                                "subtitle": {
                                                    "type": "array",
                                                    "items": [
                                                        {
                                                            "type": "string"
                                                        }
                                                    ]
                                                },
                                                "subtitleMobile": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "PROPERTY": {
                                            "type": "object",
                                            "properties": {
                                                "subtitle": {
                                                    "type": "array",
                                                    "items": [
                                                        {
                                                            "type": "string"
                                                        }
                                                    ]
                                                },
                                                "subtitleMobile": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        }
                                    }
                                },
                                "quotesLoading": {
                                    "type": "object",
                                    "properties": {
                                        "COMMON": {
                                            "type": "object",
                                            "properties": {
                                                "bottomTitle": {
                                                    "type": "string"
                                                },
                                                "nextStepsCardData": {
                                                    "type": "array",
                                                    "items": [
                                                        {
                                                            "type": "object",
                                                            "properties": {
                                                                "id": {
                                                                    "type": "string"
                                                                },
                                                                "subText": {
                                                                    "type": "string"
                                                                },
                                                                "titleText": {
                                                                    "type": "string"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "type": "object",
                                                            "properties": {
                                                                "id": {
                                                                    "type": "string"
                                                                },
                                                                "subText": {
                                                                    "type": "string"
                                                                },
                                                                "titleText": {
                                                                    "type": "string"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "type": "object",
                                                            "properties": {
                                                                "id": {
                                                                    "type": "string"
                                                                },
                                                                "subText": {
                                                                    "type": "string"
                                                                },
                                                                "titleText": {
                                                                    "type": "string"
                                                                }
                                                            }
                                                        }
                                                    ]
                                                },
                                                "subtitle": {
                                                    "type": "array",
                                                    "items": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "string"
                                                        }
                                                    ]
                                                },
                                                "subtitleMobile": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        }
                                    }
                                },
                                "animationName": {
                                    "type": "string"
                                }
                            }
                        }
                    }
                },
                "routes": {
                    "type": "object",
                    "properties": {
                        "errorScreen": {
                            "type": "object",
                            "properties": {
                                "animationName": {
                                    "type": "string"
                                },
                                "subtitleFirst": {
                                    "type": "string"
                                }
                            }
                        },
                        "finalizeContactScreen": {
                            "type": "object",
                            "properties": {
                                "animationName": {
                                    "type": "string"
                                },
                                "subtitle": {
                                    "type": "string"
                                }
                            }
                        },
                        "finalizePolicyScreen": {
                            "type": "object",
                            "properties": {
                                "title": {
                                    "type": "string"
                                }
                            }
                        },
                        "insuranceTypeSelection": {
                            "type": "object",
                            "properties": {
                                "chatWithAgentText": {
                                    "type": "string"
                                },
                                "partnerDisclaimerContent": {
                                    "type": "string"
                                }
                            }
                        },
                        "policyCompareScreen": {
                            "type": "object",
                            "properties": {
                                "additionalCarriersSubtitle": {
                                    "type": "string"
                                },
                                "DEFAULT": {
                                    "type": "object",
                                    "properties": {
                                        "returnedQuotesSubtitle": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "noQuotesReturnedSubtitle": {
                                    "type": "string"
                                }
                            }
                        },
                        "auto": {
                            "type": "object",
                            "properties": {
                                "vehicle": {
                                    "type": "object",
                                    "properties": {
                                        "addVehicleScreen": {
                                            "type": "object",
                                            "properties": {
                                                "MOTORCYCLE": {
                                                    "type": "object",
                                                    "properties": {
                                                        "headerAnimation": {
                                                            "type": "string"
                                                        },
                                                        "subtitle": {
                                                            "type": "string"
                                                        },
                                                        "title": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "PERSONAL_AUTO": {
                                                    "type": "object",
                                                    "properties": {
                                                        "headerAnimation": {
                                                            "type": "string"
                                                        },
                                                        "subtitle": {
                                                            "type": "string"
                                                        },
                                                        "title": {
                                                            "type": "string"
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "enterVinModal": {
                                            "type": "object",
                                            "properties": {
                                                "PERSONAL_AUTO": {
                                                    "type": "object",
                                                    "properties": {
                                                        "headerAnimation": {
                                                            "type": "string"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                "templates": {
                    "type": "object",
                    "properties": {
                        "addressInfoScreen": {
                            "type": "object",
                            "properties": {
                                "disclaimerText": {
                                    "type": "string"
                                },
                                "MOTORCYCLE": {
                                    "type": "object",
                                    "properties": {
                                        "subtitle": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        },
                        "insuranceStartScreen": {
                            "type": "object",
                            "properties": {
                                "disclaimer": {
                                    "type": "string"
                                }
                            }
                        },
                        "optionCardsContainerScreen": {
                            "type": "object",
                            "properties": {
                                "cohabitation": {
                                    "type": "object",
                                    "properties": {
                                        "disclaimerText": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "discounts": {
                                    "type": "object",
                                    "properties": {
                                        "disclaimerText": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        },
                        "partnerFinalizeSuccess": {
                            "type": "object",
                            "properties": {
                                "callUs": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "string"
                                        }
                                    ]
                                },
                                "disclaimerSubtitle": {
                                    "type": "string"
                                },
                                "disclaimerTitle": {
                                    "type": "string"
                                },
                                "infoLinkText": {
                                    "type": "string"
                                },
                                "policyConsent": {
                                    "type": "string"
                                },
                                "title": {
                                    "type": "string"
                                },
                                "titleOutsideHours": {
                                    "type": "string"
                                },
                                "products": {
                                    "type": "object",
                                    "properties": {
                                        "MOTORCYCLE": {
                                            "type": "object",
                                            "properties": {
                                                "subtitle": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "PERSONAL_AUTO": {
                                            "type": "object",
                                            "properties": {
                                                "subtitle": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        "driverHistory": {
                            "type": "object",
                            "properties": {
                                "staticText": {
                                    "type": "object",
                                    "properties": {
                                        "disclaimerText": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_TYPOGRAPHY",
        "schema_type_version": 2,
        "filename": "theme.json",
        "filepointer": "/baseTokens/questionnaire/typography",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/typography",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "title": "Typography",
            "type": "object",
            "definitions": {
                "fontWeight": {
                    "type": "string",
                    "pattern": "[1-9]00$"
                },
                "pixelSize": {
                    "type": "string",
                    "pattern": "[0-9]+px"
                },
                "fontFamily": {
                    "type": "string",
                    "enum": [
                        "$questionnaire.typography.fontFamily.primary",
                        "$questionnaire.typography.fontFamily.secondary"
                    ]
                }
            },
            "properties": {
                "fontFamily": {
                    "type": "object",
                    "properties": {
                        "primary": {
                            "type": "string"
                        },
                        "secondary": {
                            "type": "string"
                        }
                    },
                    "required": [
                        "primary",
                        "secondary"
                    ]
                },
                "button": {
                    "type": "object",
                    "properties": {
                        "fontWeight": {
                            "$ref": "#/definitions/fontWeight"
                        },
                        "fontSize": {
                            "$ref": "#/definitions/pixelSize"
                        },
                        "fontFamily": {
                            "$ref": "#/definitions/fontFamily"
                        }
                    }
                },
                "body": {
                    "type": "object",
                    "properties": {
                        "fontFamily": {
                            "$ref": "#/definitions/fontFamily"
                        },
                        "desktop": {
                            "type": "object",
                            "properties": {
                                "fontWeight": {
                                    "$ref": "#/definitions/fontWeight"
                                },
                                "fontWeightBold": {
                                    "$ref": "#/definitions/fontWeight"
                                },
                                "fontWeightItalic": {
                                    "$ref": "#/definitions/fontWeight"
                                }
                            }
                        },
                        "l": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        }
                                    }
                                }
                            }
                        },
                        "m": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                "heading": {
                    "type": "object",
                    "properties": {
                        "xl": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        },
                        "l": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        },
                        "m": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        },
                        "s": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        },
                        "xs": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        },
                        "xxs": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "required": [
                "fontFamily"
            ]
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_CONFIG",
        "schema_type_version": 5,
        "filename": "config.json",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/config",
            "$schema": "http://json-schema.org/draft-07/schema#",
            "title": "Config",
            "type": "object",
            "properties": {
                "EXPERIENCE_TYPE": {
                    "type": "string",
                    "enum": [
                        "cobrand",
                        "private-label",
                        "standard"
                    ],
                    "default": "standard"
                },
                "ICON_PACK": {
                    "type": "string",
                    "enum": [
                        "detailed",
                        "sharp",
                        "soft",
                        "custom",
                        "viu"
                    ]
                },
                "CTA_CASE": {
                    "type": "string",
                    "enum": [
                        "ALL_CAPS",
                        "TITLE_CASE"
                    ]
                },
                "PHONE_MASK": {
                    "type": "string"
                },
                "PHONE_NUMBER": {
                    "type": "string"
                },
                "SUPPORTED_INSURANCE_LINES": {
                    "type": "object",
                    "properties": {
                        "CONDOMINIUM": {
                            "type": "boolean",
                            "default": true
                        },
                        "LANDLORD": {
                            "type": "boolean",
                            "default": true
                        },
                        "LIFE": {
                            "type": "boolean",
                            "default": false
                        },
                        "MOTORCYCLE": {
                            "type": "boolean",
                            "default": true
                        },
                        "PERSONAL_AUTO": {
                            "type": "boolean",
                            "default": true
                        },
                        "PERSONAL_HOME": {
                            "type": "boolean",
                            "default": true
                        },
                        "PET": {
                            "type": "boolean",
                            "default": false
                        },
                        "RENTERS": {
                            "type": "boolean",
                            "default": true
                        }
                    }
                }
            },
            "required": [
                "SUPPORTED_INSURANCE_LINES",
                "ICON_PACK",
                "EXPERIENCE_TYPE"
            ]
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_CONFIG",
        "schema_type_version": 6,
        "filename": "config.json",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/config",
            "$schema": "http://json-schema.org/draft-07/schema#",
            "title": "Config",
            "type": "object",
            "properties": {
                "EXPERIENCE_TYPE": {
                    "type": "string",
                    "enum": [
                        "cobrand",
                        "private-label",
                        "standard"
                    ],
                    "default": "standard"
                },
                "ICON_PACK": {
                    "type": "string",
                    "enum": [
                        "detailed",
                        "sharp",
                        "soft",
                        "custom",
                        "viu"
                    ]
                },
                "CTA_CASE": {
                    "type": "string",
                    "enum": [
                        "ALL_CAPS",
                        "TITLE_CASE",
                        "SENTENCE_CASE"
                    ]
                },
                "PHONE_MASK": {
                    "type": "string"
                },
                "PHONE_NUMBER": {
                    "type": "string"
                },
                "SUPPORTED_INSURANCE_LINES": {
                    "type": "object",
                    "properties": {
                        "CONDOMINIUM": {
                            "type": "boolean",
                            "default": true
                        },
                        "LANDLORD": {
                            "type": "boolean",
                            "default": true
                        },
                        "LIFE": {
                            "type": "boolean",
                            "default": false
                        },
                        "MOTORCYCLE": {
                            "type": "boolean",
                            "default": true
                        },
                        "PERSONAL_AUTO": {
                            "type": "boolean",
                            "default": true
                        },
                        "PERSONAL_HOME": {
                            "type": "boolean",
                            "default": true
                        },
                        "PET": {
                            "type": "boolean",
                            "default": false
                        },
                        "RENTERS": {
                            "type": "boolean",
                            "default": true
                        }
                    }
                }
            },
            "required": [
                "SUPPORTED_INSURANCE_LINES",
                "ICON_PACK",
                "EXPERIENCE_TYPE"
            ]
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_IMAGES",
        "schema_type_version": 2,
        "filename": "theme.json",
        "filepointer": "/baseTokens/questionnaire/images",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/images",
            "$schema": "http://json-schema.org/draft-07/schema#",
            "title": "Images",
            "type": "object",
            "properties": {
                "addressInfoScreen": {
                    "type": "object",
                    "properties": {
                        "MOTORCYCLE": {
                            "type": "object",
                            "properties": {
                                "hero": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        },
                        "PERSONAL_AUTO": {
                            "type": "object",
                            "properties": {
                                "hero": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        },
                        "PROPERTY": {
                            "type": "object",
                            "properties": {
                                "hero": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        }
                    }
                },
                "addVehicleScreen": {
                    "type": "object",
                    "properties": {
                        "MOTORCYCLE": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        },
                        "PERSONAL_AUTO": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        }
                    }
                },
                "complexCaseModal": {
                    "type": "object",
                    "properties": {
                        "noQuotesReturned": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        },
                        "noQuotesReturnedByOtherInsuranceLine": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        },
                        "noQuotesReturnedOnDigitalBindReview": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        }
                    }
                },
                "confirmEmailModal": {
                    "type": "object",
                    "properties": {
                        "formHeader": {
                            "type": "string"
                        }
                    }
                },
                "enterVinModal": {
                    "type": "object",
                    "properties": {
                        "MOTORCYCLE": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        },
                        "PERSONAL_AUTO": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        }
                    }
                },
                "insuranceTypeSelection": {
                    "type": "object",
                    "properties": {
                        "formHeader": {
                            "type": "string"
                        }
                    }
                },
                "partnerFinalizeSuccess": {
                    "type": "object",
                    "properties": {
                        "MOTORCYCLE": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        },
                        "PERSONAL_AUTO": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        },
                        "PROPERTY": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "string"
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_LOCALIZATIONS",
        "schema_type_version": 3,
        "filename": "localizations.json",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/localizations",
            "$schema": "http://json-schema.org/draft-07/schema#",
            "title": "Localizations",
            "type": "object",
            "properties": {
                "molecules": {
                    "type": "object",
                    "properties": {
                        "confirmEmailModal": {
                            "type": "object",
                            "properties": {
                                "animationName": {
                                    "type": "string"
                                },
                                "ctaEmailQuotesModal": {
                                    "type": "string"
                                }
                            }
                        },
                        "globalBackButton": {
                            "type": "object",
                            "properties": {
                                "ctaText": {
                                    "type": "string"
                                }
                            }
                        },
                        "partnerDisclaimer": {
                            "type": "object",
                            "properties": {
                                "disclaimerTextCobrand": {
                                    "type": "string"
                                }
                            }
                        },
                        "policyCompareCard": {
                            "type": "object",
                            "properties": {
                                "autoQuoteSummary": {
                                    "type": "object",
                                    "properties": {
                                        "CTA": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "propertyQuoteSummary": {
                                    "type": "object",
                                    "properties": {
                                        "CTA": {
                                            "type": "string"
                                        },
                                        "label": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        },
                        "privacyDisclaimer": {
                            "type": "object",
                            "properties": {
                                "privacy": {
                                    "type": "string"
                                },
                                "terms": {
                                    "type": "string"
                                },
                                "text1": {
                                    "type": "string"
                                },
                                "text2": {
                                    "type": "string"
                                },
                                "partnerPretext": {
                                    "type": "string"
                                },
                                "partnerPosttext": {
                                    "type": "string"
                                },
                                "partnerPrivacy": {
                                    "type": "string"
                                },
                                "partnerPrivacyLink": {
                                    "type": "string"
                                },
                                "text3": {
                                    "type": "string"
                                }
                            }
                        },
                        "quoteCard": {
                            "type": "object",
                            "properties": {
                                "ctaHideDetailsAccordionText": {
                                    "type": "string"
                                },
                                "ctaPet": {
                                    "type": "string"
                                },
                                "ctaPurchase": {
                                    "type": "string"
                                },
                                "ctaSelect": {
                                    "type": "string"
                                },
                                "ctaSelectAdditionalCarrier": {
                                    "type": "string"
                                },
                                "ctaShowDetailsAccordionText": {
                                    "type": "string"
                                },
                                "discountDisclaimer": {
                                    "type": "string"
                                }
                            }
                        },
                        "quoteDetailModal": {
                            "type": "object",
                            "properties": {
                                "CONDOMINIUM": {
                                    "type": "object",
                                    "properties": {
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "cta": {
                                    "type": "string"
                                },
                                "LANDLORD": {
                                    "type": "object",
                                    "properties": {
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "LIFE": {
                                    "type": "object",
                                    "properties": {
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "mobileCta": {
                                    "type": "string"
                                },
                                "MOTORCYCLE": {
                                    "type": "object",
                                    "properties": {
                                        "deductibleTitle": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "PERSONAL_AUTO": {
                                    "type": "object",
                                    "properties": {
                                        "deductibleTitle": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "PERSONAL_HOME": {
                                    "type": "object",
                                    "properties": {
                                        "deductibleSubtitle": {
                                            "type": "string"
                                        },
                                        "deductibleTitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "RENTERS": {
                                    "type": "object",
                                    "properties": {
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                "organisms": {
                    "type": "object",
                    "properties": {
                        "complexModal": {
                            "type": "object",
                            "properties": {
                                "scenarios": {
                                    "type": "object",
                                    "properties": {
                                        "addressNotFound": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "ctaCloseMessage": {
                                                    "type": "string"
                                                },
                                                "ctaMessage": {
                                                    "type": "string"
                                                },
                                                "subtitle": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "codeNotSupported": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "ctaCloseMessage": {
                                                    "type": "string"
                                                },
                                                "ctaMessage": {
                                                    "type": "string"
                                                },
                                                "subtitle": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "insuranceCanBeTricky": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "ctaCloseMessage": {
                                                    "type": "string"
                                                },
                                                "ctaMessage": {
                                                    "type": "string"
                                                },
                                                "subtitle": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "insuranceCanBeTrickyLocalAgent": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "ctaCloseMessage": {
                                                    "type": "string"
                                                },
                                                "ctaMessage": {
                                                    "type": "string"
                                                },
                                                "subtitle": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "lifeCaseOverMaxDoB": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "ctaCloseMessage": {
                                                    "type": "string"
                                                },
                                                "ctaMessage": {
                                                    "type": "string"
                                                },
                                                "subtitle": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "lifeCaseUnderMinDoB": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "ctaCloseMessage": {
                                                    "type": "string"
                                                },
                                                "ctaMessage": {
                                                    "type": "string"
                                                },
                                                "subtitle": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "mostAccurateQuotes": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "ctaCloseMessage": {
                                                    "type": "string"
                                                },
                                                "ctaMessage": {
                                                    "type": "string"
                                                },
                                                "subtitle": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "noQuotesReturned": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "ctaCloseMessage": {
                                                    "type": "string"
                                                },
                                                "ctaMessage": {
                                                    "type": "string"
                                                },
                                                "subtitle": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "noQuotesReturnedByOtherInsuranceLine": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "ctaCloseMessage": {
                                                    "type": "string"
                                                },
                                                "subtitle": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                },
                                                "ctaMessage": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "trickyCaseConnectViaPhone": {
                                            "type": "object",
                                            "properties": {
                                                "animationName": {
                                                    "type": "string"
                                                },
                                                "ctaCloseMessage": {
                                                    "type": "string"
                                                },
                                                "ctaMessage": {
                                                    "type": "string"
                                                },
                                                "subtitle": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        "customizeModal": {
                            "type": "object",
                            "properties": {
                                "CONDOMINIUM": {
                                    "type": "object",
                                    "properties": {
                                        "ctaMessage": {
                                            "type": "string"
                                        },
                                        "ctaMessageNoChanges": {
                                            "type": "string"
                                        },
                                        "disclaimerText": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "LANDLORD": {
                                    "type": "object",
                                    "properties": {
                                        "ctaMessage": {
                                            "type": "string"
                                        },
                                        "ctaMessageNoChanges": {
                                            "type": "string"
                                        },
                                        "disclaimerText": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "LIFE": {
                                    "type": "object",
                                    "properties": {
                                        "calculatorButton": {
                                            "type": "string"
                                        },
                                        "calculatorQuestion": {
                                            "type": "string"
                                        },
                                        "ctaMessage": {
                                            "type": "string"
                                        },
                                        "ctaMessageNoChanges": {
                                            "type": "string"
                                        },
                                        "disclaimerText": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "MOTORCYCLE": {
                                    "type": "object",
                                    "properties": {
                                        "ctaMessage": {
                                            "type": "string"
                                        },
                                        "ctaMessageNoChanges": {
                                            "type": "string"
                                        },
                                        "ctaNextButton": {
                                            "type": "string"
                                        },
                                        "disclaimerOptOutFirst": {
                                            "type": "string"
                                        },
                                        "disclaimerOptOutNotOwned": {
                                            "type": "string"
                                        },
                                        "disclaimerOptOutOwned": {
                                            "type": "string"
                                        },
                                        "disclaimerText": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "PERSONAL_AUTO": {
                                    "type": "object",
                                    "properties": {
                                        "ctaMessage": {
                                            "type": "string"
                                        },
                                        "ctaMessageNoChanges": {
                                            "type": "string"
                                        },
                                        "ctaNextButton": {
                                            "type": "string"
                                        },
                                        "disclaimerOptOutFirst": {
                                            "type": "string"
                                        },
                                        "disclaimerOptOutNotOwned": {
                                            "type": "string"
                                        },
                                        "disclaimerOptOutOwned": {
                                            "type": "string"
                                        },
                                        "disclaimerText": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "PERSONAL_HOME": {
                                    "type": "object",
                                    "properties": {
                                        "ctaMessage": {
                                            "type": "string"
                                        },
                                        "ctaMessageNoChanges": {
                                            "type": "string"
                                        },
                                        "disclaimerText": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "RENTERS": {
                                    "type": "object",
                                    "properties": {
                                        "ctaMessage": {
                                            "type": "string"
                                        },
                                        "ctaMessageNoChanges": {
                                            "type": "string"
                                        },
                                        "disclaimerText": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        },
                        "partnerLoadingScreen": {
                            "type": "object",
                            "properties": {
                                "prefill": {
                                    "type": "object",
                                    "properties": {
                                        "PERSONAL_AUTO": {
                                            "type": "object",
                                            "properties": {
                                                "subtitle": {
                                                    "type": "array",
                                                    "items": [
                                                        {
                                                            "type": "string"
                                                        }
                                                    ]
                                                },
                                                "subtitleMobile": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "PROPERTY": {
                                            "type": "object",
                                            "properties": {
                                                "subtitle": {
                                                    "type": "array",
                                                    "items": [
                                                        {
                                                            "type": "string"
                                                        }
                                                    ]
                                                },
                                                "subtitleMobile": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        }
                                    }
                                },
                                "quotesLoading": {
                                    "type": "object",
                                    "properties": {
                                        "COMMON": {
                                            "type": "object",
                                            "properties": {
                                                "bottomTitle": {
                                                    "type": "string"
                                                },
                                                "nextStepsCardData": {
                                                    "type": "array",
                                                    "items": [
                                                        {
                                                            "type": "object",
                                                            "properties": {
                                                                "id": {
                                                                    "type": "string"
                                                                },
                                                                "subText": {
                                                                    "type": "string"
                                                                },
                                                                "titleText": {
                                                                    "type": "string"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "type": "object",
                                                            "properties": {
                                                                "id": {
                                                                    "type": "string"
                                                                },
                                                                "subText": {
                                                                    "type": "string"
                                                                },
                                                                "titleText": {
                                                                    "type": "string"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "type": "object",
                                                            "properties": {
                                                                "id": {
                                                                    "type": "string"
                                                                },
                                                                "subText": {
                                                                    "type": "string"
                                                                },
                                                                "titleText": {
                                                                    "type": "string"
                                                                }
                                                            }
                                                        }
                                                    ]
                                                },
                                                "subtitle": {
                                                    "type": "array",
                                                    "items": [
                                                        {
                                                            "type": "string"
                                                        },
                                                        {
                                                            "type": "string"
                                                        }
                                                    ]
                                                },
                                                "subtitleMobile": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        }
                                    }
                                },
                                "animationName": {
                                    "type": "string"
                                }
                            }
                        }
                    }
                },
                "routes": {
                    "type": "object",
                    "properties": {
                        "auto": {
                            "type": "object",
                            "properties": {
                                "vehicle": {
                                    "type": "object",
                                    "properties": {
                                        "addVehicleScreen": {
                                            "type": "object",
                                            "properties": {
                                                "COMMON": {
                                                    "type": "object",
                                                    "properties": {
                                                        "ctaComplex": {
                                                            "type": "string"
                                                        },
                                                        "ctaManualVINEntryDesktop": {
                                                            "type": "string"
                                                        },
                                                        "ctaManualVINEntryMobile": {
                                                            "type": "string"
                                                        },
                                                        "ctaModal": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "MOTORCYCLE": {
                                                    "type": "object",
                                                    "properties": {
                                                        "ctaContinue": {
                                                            "type": "string"
                                                        },
                                                        "headerAnimation": {
                                                            "type": "string"
                                                        },
                                                        "incompleteMakeErrorMessage": {
                                                            "type": "string"
                                                        },
                                                        "subtitle": {
                                                            "type": "string"
                                                        },
                                                        "title": {
                                                            "type": "string"
                                                        },
                                                        "useCorrectSelection": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "PERSONAL_AUTO": {
                                                    "type": "object",
                                                    "properties": {
                                                        "ctaContinue": {
                                                            "type": "string"
                                                        },
                                                        "headerAnimation": {
                                                            "type": "string"
                                                        },
                                                        "incompleteMakeErrorMessage": {
                                                            "type": "string"
                                                        },
                                                        "subtitle": {
                                                            "type": "string"
                                                        },
                                                        "title": {
                                                            "type": "string"
                                                        },
                                                        "useCorrectSelection": {
                                                            "type": "string"
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "COMMON": {
                                            "type": "object",
                                            "properties": {
                                                "ctaAddAnotherVehicle": {
                                                    "type": "string"
                                                },
                                                "ctaAddVehicle": {
                                                    "type": "string"
                                                },
                                                "ctaSubmit": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "enterVinModal": {
                                            "type": "object",
                                            "properties": {
                                                "COMMON": {
                                                    "type": "object",
                                                    "properties": {
                                                        "cta": {
                                                            "type": "string"
                                                        },
                                                        "ctaManualEntry": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "MOTORCYCLE": {
                                                    "type": "object",
                                                    "properties": {
                                                        "subtitle": {
                                                            "type": "string"
                                                        },
                                                        "title": {
                                                            "type": "string"
                                                        }
                                                    }
                                                },
                                                "PERSONAL_AUTO": {
                                                    "type": "object",
                                                    "properties": {
                                                        "headerAnimation": {
                                                            "type": "string"
                                                        },
                                                        "subtitle": {
                                                            "type": "string"
                                                        },
                                                        "title": {
                                                            "type": "string"
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "ownershipContent": {
                                            "type": "object",
                                            "properties": {
                                                "selectOptions": {
                                                    "type": "array",
                                                    "items": [
                                                        {
                                                            "type": "object",
                                                            "properties": {
                                                                "label": {
                                                                    "type": "string"
                                                                },
                                                                "value": {
                                                                    "type": "string"
                                                                }
                                                            }
                                                        },
                                                        {
                                                            "type": "object",
                                                            "properties": {
                                                                "label": {
                                                                    "type": "string"
                                                                },
                                                                "value": {
                                                                    "type": "string"
                                                                }
                                                            }
                                                        }
                                                    ]
                                                },
                                                "tooltipProps": {
                                                    "type": "object",
                                                    "properties": {
                                                        "content": {
                                                            "type": "string"
                                                        },
                                                        "title": {
                                                            "type": "string"
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        },
                        "condoPrefill": {
                            "type": "object",
                            "properties": {
                                "cta": {
                                    "type": "string"
                                },
                                "ctaRebuildRefresh": {
                                    "type": "string"
                                },
                                "subtitle": {
                                    "type": "string"
                                },
                                "title": {
                                    "type": "string"
                                }
                            }
                        },
                        "errorScreen": {
                            "type": "object",
                            "properties": {
                                "animationName": {
                                    "type": "string"
                                },
                                "cta": {
                                    "type": "string"
                                },
                                "header": {
                                    "type": "string"
                                },
                                "subtitleEnd": {
                                    "type": "string"
                                },
                                "subtitleFirst": {
                                    "type": "string"
                                }
                            }
                        },
                        "finalizeContactScreen": {
                            "type": "object",
                            "properties": {
                                "animationName": {
                                    "type": "string"
                                },
                                "cta": {
                                    "type": "string"
                                },
                                "subtitle": {
                                    "type": "string"
                                },
                                "title": {
                                    "type": "string"
                                }
                            }
                        },
                        "finalizePolicyScreen": {
                            "type": "object",
                            "properties": {
                                "cta": {
                                    "type": "string"
                                },
                                "ctaCarrierPill": {
                                    "type": "string"
                                },
                                "title": {
                                    "type": "string"
                                }
                            }
                        },
                        "homeownersPrefillScreen": {
                            "type": "object",
                            "properties": {
                                "cta": {
                                    "type": "string"
                                },
                                "ctaRebuildRefresh": {
                                    "type": "string"
                                },
                                "subtitle": {
                                    "type": "string"
                                },
                                "title": {
                                    "type": "string"
                                }
                            }
                        },
                        "insuranceTypeSelection": {
                            "type": "object",
                            "properties": {
                                "chatWithAgentText": {
                                    "type": "string"
                                },
                                "disclaimerText": {
                                    "type": "string"
                                },
                                "productCards": {
                                    "type": "object",
                                    "properties": {
                                        "autoText": {
                                            "type": "string"
                                        },
                                        "condoText": {
                                            "type": "string"
                                        },
                                        "homeownersText": {
                                            "type": "string"
                                        },
                                        "landlordText": {
                                            "type": "string"
                                        },
                                        "lifeText": {
                                            "type": "string"
                                        },
                                        "motorcycleText": {
                                            "type": "string"
                                        },
                                        "petText": {
                                            "type": "string"
                                        },
                                        "rentersText": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "subtitle": {
                                    "type": "string"
                                },
                                "title": {
                                    "type": "string"
                                },
                                "partnerDisclaimerContent": {
                                    "type": "string"
                                }
                            }
                        },
                        "policyCompareScreen": {
                            "type": "object",
                            "properties": {
                                "additionalCarriersSubtitle": {
                                    "type": "string"
                                },
                                "additionalCarriersTitle": {
                                    "type": "string"
                                },
                                "ctaCoverageText": {
                                    "type": "string"
                                },
                                "ctaEmailQuotes": {
                                    "type": "string"
                                },
                                "ctaSupportSubtitle": {
                                    "type": "string"
                                },
                                "DEFAULT": {
                                    "type": "object",
                                    "properties": {
                                        "ctaViewCoverages": {
                                            "type": "string"
                                        },
                                        "ctaViewDeductibles": {
                                            "type": "string"
                                        },
                                        "returnedQuotesSubtitle": {
                                            "type": "string"
                                        },
                                        "returnedQuotesTitle": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "LIFE": {
                                    "type": "object",
                                    "properties": {
                                        "calculatorButton": {
                                            "type": "string"
                                        },
                                        "calculatorQuestion": {
                                            "type": "string"
                                        },
                                        "ctaViewCoverages": {
                                            "type": "string"
                                        },
                                        "returnedQuotesSubtitle": {
                                            "type": "string"
                                        },
                                        "returnedQuotesTitle": {
                                            "type": "string"
                                        },
                                        "viewCoveragesSubtitle": {
                                            "type": "string"
                                        },
                                        "viewCoverageTitle": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "noQuotesReturnedSubtitle": {
                                    "type": "string"
                                },
                                "noQuotesReturnedTitle": {
                                    "type": "string"
                                },
                                "PET": {
                                    "type": "object",
                                    "properties": {
                                        "disclaimerText": {
                                            "type": "string"
                                        },
                                        "returnedQuotesSubtitle": {
                                            "type": "string"
                                        },
                                        "returnedQuotesTitle": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "supportTitle": {
                                    "type": "string"
                                },
                                "viewCoverages": {
                                    "type": "string"
                                },
                                "viewCoveragesSubtitle": {
                                    "type": "string"
                                }
                            }
                        }
                    }
                },
                "templates": {
                    "type": "object",
                    "properties": {
                        "additionalInfoScreen": {
                            "type": "object",
                            "properties": {
                                "/auto/annual-mileage": {
                                    "type": "object",
                                    "properties": {
                                        "cta": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "/auto/prior-bodily-injury/": {
                                    "type": "object",
                                    "properties": {
                                        "cta": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "/auto/years-continuous-coverage": {
                                    "type": "object",
                                    "properties": {
                                        "cta": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "/landlord/home-type": {
                                    "type": "object",
                                    "properties": {
                                        "cta": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "/landlord/usage": {
                                    "type": "object",
                                    "properties": {
                                        "cta": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "/motorcycle/annual-mileage": {
                                    "type": "object",
                                    "properties": {
                                        "cta": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        },
                        "addressInfoScreen": {
                            "type": "object",
                            "properties": {
                                "COMMON": {
                                    "type": "object",
                                    "properties": {
                                        "cta": {
                                            "type": "string"
                                        },
                                        "ctaContractText": {
                                            "type": "string"
                                        },
                                        "ctaExpandText": {
                                            "type": "string"
                                        },
                                        "invalidTitleMessage": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "CONDOMINIUM": {
                                    "type": "object",
                                    "properties": {
                                        "headerAnimation": {
                                            "type": "string"
                                        },
                                        "invalidSubtitleMessage": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "LANDLORD": {
                                    "type": "object",
                                    "properties": {
                                        "headerAnimation": {
                                            "type": "string"
                                        },
                                        "invalidSubtitleMessage": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "MOTORCYCLE": {
                                    "type": "object",
                                    "properties": {
                                        "headerAnimation": {
                                            "type": "string"
                                        },
                                        "invalidSubtitleMessage": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "PERSONAL_AUTO": {
                                    "type": "object",
                                    "properties": {
                                        "headerAnimation": {
                                            "type": "string"
                                        },
                                        "invalidSubtitleMessage": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "PERSONAL_HOME": {
                                    "type": "object",
                                    "properties": {
                                        "headerAnimation": {
                                            "type": "string"
                                        },
                                        "invalidSubtitleMessage": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "RENTERS": {
                                    "type": "object",
                                    "properties": {
                                        "headerAnimation": {
                                            "type": "string"
                                        },
                                        "invalidSubtitleMessage": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "disclaimerText": {
                                    "type": "string"
                                }
                            }
                        },
                        "bundlingScreen": {
                            "type": "object",
                            "properties": {
                                "COMMON": {
                                    "type": "object",
                                    "properties": {
                                        "cta": {
                                            "type": "string"
                                        },
                                        "ctaDisclaimerLink": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "CONDOMINIUM": {
                                    "type": "object",
                                    "properties": {
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "PERSONAL_AUTO": {
                                    "type": "object",
                                    "properties": {
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "PERSONAL_HOME": {
                                    "type": "object",
                                    "properties": {
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "RENTERS": {
                                    "type": "object",
                                    "properties": {
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        },
                        "driverHistory": {
                            "type": "object",
                            "properties": {
                                "staticText": {
                                    "type": "object",
                                    "properties": {
                                        "COMMON": {
                                            "type": "object",
                                            "properties": {
                                                "cta": {
                                                    "type": "string"
                                                },
                                                "ctaNextDriver": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "disclaimerText": {
                                            "type": "string"
                                        },
                                        "subtitleEnd": {
                                            "type": "string"
                                        },
                                        "subtitleMiddle": {
                                            "type": "string"
                                        },
                                        "subtitleStart": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        },
                        "driversInfoScreen": {
                            "type": "object",
                            "properties": {
                                "COMMON": {
                                    "type": "object",
                                    "properties": {
                                        "cta": {
                                            "type": "string"
                                        },
                                        "ctaAddAnotherDriver": {
                                            "type": "string"
                                        },
                                        "ctaAddDriver": {
                                            "type": "string"
                                        },
                                        "ctaEdit": {
                                            "type": "string"
                                        },
                                        "ctaRemove": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "MOTORCYCLE": {
                                    "type": "object",
                                    "properties": {
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "PERSONAL_AUTO": {
                                    "type": "object",
                                    "properties": {
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        },
                        "finalizeSuccessScreen": {
                            "type": "object",
                            "properties": {
                                "animationName": {
                                    "type": "string"
                                },
                                "callUs": {
                                    "type": "string"
                                },
                                "callUsMobile": {
                                    "type": "string"
                                },
                                "cta": {
                                    "type": "string"
                                },
                                "disclaimerNote": {
                                    "type": "string"
                                },
                                "title": {
                                    "type": "string"
                                }
                            }
                        },
                        "insuranceStartScreen": {
                            "type": "object",
                            "properties": {
                                "adobeTrackingEvent": {
                                    "type": "object",
                                    "properties": {
                                        "CONDOMINIUM": {
                                            "type": "string"
                                        },
                                        "LANDLORD": {
                                            "type": "string"
                                        },
                                        "RENTERS": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "cta": {
                                    "type": "string"
                                },
                                "disclaimer": {
                                    "type": "string"
                                },
                                "seo": {
                                    "type": "object",
                                    "properties": {
                                        "CONDOMINIUM": {
                                            "type": "object",
                                            "properties": {
                                                "description": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "LANDLORD": {
                                            "type": "object",
                                            "properties": {
                                                "description": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "RENTERS": {
                                            "type": "object",
                                            "properties": {
                                                "description": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        }
                                    }
                                },
                                "subtitle": {
                                    "type": "string"
                                },
                                "title": {
                                    "type": "string"
                                }
                            }
                        },
                        "optionCardsContainerScreen": {
                            "type": "object",
                            "properties": {
                                "cohabitation": {
                                    "type": "object",
                                    "properties": {
                                        "cta": {
                                            "type": "string"
                                        },
                                        "disclaimerText": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "discounts": {
                                    "type": "object",
                                    "properties": {
                                        "cta": {
                                            "type": "string"
                                        },
                                        "disclaimerText": {
                                            "type": "string"
                                        },
                                        "discountsAvailable": {
                                            "type": "array",
                                            "items": [
                                                {
                                                    "type": "object",
                                                    "properties": {
                                                        "animatedIcon": {
                                                            "type": "string"
                                                        },
                                                        "discountTitle": {
                                                            "type": "string"
                                                        },
                                                        "id": {
                                                            "type": "string"
                                                        },
                                                        "isActive": {
                                                            "type": "boolean"
                                                        }
                                                    }
                                                },
                                                {
                                                    "type": "object",
                                                    "properties": {
                                                        "animatedIcon": {
                                                            "type": "string"
                                                        },
                                                        "discountTitle": {
                                                            "type": "string"
                                                        },
                                                        "id": {
                                                            "type": "string"
                                                        },
                                                        "isActive": {
                                                            "type": "boolean"
                                                        }
                                                    }
                                                },
                                                {
                                                    "type": "object",
                                                    "properties": {
                                                        "animatedIcon": {
                                                            "type": "string"
                                                        },
                                                        "discountTitle": {
                                                            "type": "string"
                                                        },
                                                        "id": {
                                                            "type": "string"
                                                        },
                                                        "isActive": {
                                                            "type": "boolean"
                                                        }
                                                    }
                                                },
                                                {
                                                    "type": "object",
                                                    "properties": {
                                                        "animatedIcon": {
                                                            "type": "string"
                                                        },
                                                        "discountTitle": {
                                                            "type": "string"
                                                        },
                                                        "id": {
                                                            "type": "string"
                                                        },
                                                        "isActive": {
                                                            "type": "boolean"
                                                        }
                                                    }
                                                },
                                                {
                                                    "type": "object",
                                                    "properties": {
                                                        "animatedIcon": {
                                                            "type": "string"
                                                        },
                                                        "discountTitle": {
                                                            "type": "string"
                                                        },
                                                        "id": {
                                                            "type": "string"
                                                        },
                                                        "isActive": {
                                                            "type": "boolean"
                                                        }
                                                    }
                                                },
                                                {
                                                    "type": "object",
                                                    "properties": {
                                                        "animatedIcon": {
                                                            "type": "string"
                                                        },
                                                        "discountTitle": {
                                                            "type": "string"
                                                        },
                                                        "id": {
                                                            "type": "string"
                                                        },
                                                        "isActive": {
                                                            "type": "boolean"
                                                        }
                                                    }
                                                }
                                            ]
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        },
                        "personalInfoScreen": {
                            "type": "object",
                            "properties": {
                                "DEFAULT": {
                                    "type": "object",
                                    "properties": {
                                        "cta": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "HONEY_QUOTE": {
                                    "type": "object",
                                    "properties": {
                                        "cta": {
                                            "type": "string"
                                        },
                                        "licenseHoneyQuote": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                },
                                "LIFE": {
                                    "type": "object",
                                    "properties": {
                                        "cta": {
                                            "type": "string"
                                        },
                                        "subtitle": {
                                            "type": "string"
                                        },
                                        "title": {
                                            "type": "string"
                                        }
                                    }
                                }
                            }
                        },
                        "prefillFormScreen": {
                            "type": "object",
                            "properties": {
                                "cta": {
                                    "type": "string"
                                },
                                "ctaRebuildRefresh": {
                                    "type": "string"
                                },
                                "subtitle": {
                                    "type": "string"
                                },
                                "title": {
                                    "type": "string"
                                }
                            }
                        },
                        "partnerFinalizeSuccess": {
                            "type": "object",
                            "properties": {
                                "callUs": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": "string"
                                        },
                                        {
                                            "type": "string"
                                        }
                                    ]
                                },
                                "disclaimerSubtitle": {
                                    "type": "string"
                                },
                                "disclaimerTitle": {
                                    "type": "string"
                                },
                                "infoLinkText": {
                                    "type": "string"
                                },
                                "policyConsent": {
                                    "type": "string"
                                },
                                "title": {
                                    "type": "string"
                                },
                                "titleOutsideHours": {
                                    "type": "string"
                                },
                                "products": {
                                    "type": "object",
                                    "properties": {
                                        "MOTORCYCLE": {
                                            "type": "object",
                                            "properties": {
                                                "subtitle": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        },
                                        "PERSONAL_AUTO": {
                                            "type": "object",
                                            "properties": {
                                                "subtitle": {
                                                    "type": "string"
                                                },
                                                "title": {
                                                    "type": "string"
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_IMAGES",
        "schema_type_version": 3,
        "filename": "theme.json",
        "filepointer": "/baseTokens/questionnaire/images",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/images",
            "$schema": "http://json-schema.org/draft-07/schema#",
            "title": "Images",
            "type": "object",
            "properties": {
                "addressInfoScreen": {
                    "type": "object",
                    "properties": {
                        "MOTORCYCLE": {
                            "type": "object",
                            "properties": {
                                "hero": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        },
                        "PERSONAL_AUTO": {
                            "type": "object",
                            "properties": {
                                "hero": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        },
                        "PROPERTY": {
                            "type": "object",
                            "properties": {
                                "hero": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        }
                    }
                },
                "addVehicleScreen": {
                    "type": "object",
                    "properties": {
                        "MOTORCYCLE": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        },
                        "PERSONAL_AUTO": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        }
                    }
                },
                "complexCaseModal": {
                    "type": "object",
                    "properties": {
                        "noQuotesReturned": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        },
                        "noQuotesReturnedByOtherInsuranceLine": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        },
                        "noQuotesReturnedOnDigitalBindReview": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        }
                    }
                },
                "confirmEmailModal": {
                    "type": "object",
                    "properties": {
                        "formHeader": {
                            "type": "array",
                            "items": [
                                {
                                    "type": [
                                        "string",
                                        "null"
                                    ]
                                }
                            ]
                        }
                    }
                },
                "enterVinModal": {
                    "type": "object",
                    "properties": {
                        "MOTORCYCLE": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        },
                        "PERSONAL_AUTO": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        }
                    }
                },
                "insuranceTypeSelection": {
                    "type": "object",
                    "properties": {
                        "formHeader": {
                            "type": "array",
                            "items": [
                                {
                                    "type": [
                                        "string",
                                        "null"
                                    ]
                                }
                            ]
                        }
                    }
                },
                "partnerFinalizeSuccess": {
                    "type": "object",
                    "properties": {
                        "MOTORCYCLE": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        },
                        "PERSONAL_AUTO": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        },
                        "PROPERTY": {
                            "type": "object",
                            "properties": {
                                "formHeader": {
                                    "type": "array",
                                    "items": [
                                        {
                                            "type": [
                                                "string",
                                                "null"
                                            ]
                                        }
                                    ]
                                }
                            }
                        }
                    }
                },
                "partnerLoadingScreen": {
                    "type": "array",
                    "items": [
                        {
                            "type": [
                                "string",
                                "null"
                            ]
                        }
                    ]
                }
            }
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_CONFIG",
        "schema_type_version": 7,
        "filename": "config.json",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/config",
            "$schema": "http://json-schema.org/draft-07/schema#",
            "title": "Config",
            "type": "object",
            "properties": {
                "EXPERIENCE_TYPE": {
                    "type": "string",
                    "enum": [
                        "cobrand",
                        "private-label",
                        "standard"
                    ],
                    "default": "standard"
                },
                "ICON_PACK": {
                    "type": "string",
                    "enum": [
                        "detailed",
                        "sharp",
                        "soft",
                        "custom",
                        "viu"
                    ]
                },
                "CTA_CASE": {
                    "type": "string",
                    "enum": [
                        "ALL_CAPS",
                        "TITLE_CASE",
                        "SENTENCE_CASE"
                    ]
                },
                "PHONE_MASK": {
                    "type": "string"
                },
                "PHONE_NUMBER": {
                    "type": "string"
                },
                "SUPPORTED_INSURANCE_LINES": {
                    "type": "object",
                    "properties": {
                        "CONDOMINIUM": {
                            "type": "boolean",
                            "default": true
                        },
                        "LANDLORD": {
                            "type": "boolean",
                            "default": true
                        },
                        "LIFE": {
                            "type": "boolean",
                            "default": false
                        },
                        "MOTORCYCLE": {
                            "type": "boolean",
                            "default": true
                        },
                        "PERSONAL_AUTO": {
                            "type": "boolean",
                            "default": true
                        },
                        "PERSONAL_HOME": {
                            "type": "boolean",
                            "default": true
                        },
                        "PET": {
                            "type": "boolean",
                            "default": false
                        },
                        "RENTERS": {
                            "type": "boolean",
                            "default": true
                        }
                    },
                    "default": {
                        "PERSONAL_AUTO": true,
                        "PERSONAL_HOME": true,
                        "RENTERS": true,
                        "LIFE": false,
                        "CONDOMINIUM": true,
                        "MOTORCYCLE": true,
                        "LANDLORD": true,
                        "PET": false
                    }
                },
                "ORDERED_INSURANCE_LINES": {
                    "type": "array",
                    "items": {
                        "type": "string",
                        "enum": [
                            "CONDOMINIUM",
                            "LANDLORD",
                            "LIFE",
                            "MOTORCYCLE",
                            "PERSONAL_AUTO",
                            "PERSONAL_HOME",
                            "PET",
                            "RENTERS"
                        ]
                    },
                    "default": [
                        "PERSONAL_AUTO",
                        "PERSONAL_HOME",
                        "RENTERS",
                        "LIFE",
                        "CONDOMINIUM",
                        "MOTORCYCLE",
                        "LANDLORD",
                        "PET"
                    ],
                    "uniqueItems": true
                }
            },
            "required": [
                "SUPPORTED_INSURANCE_LINES",
                "ORDERED_INSURANCE_LINES",
                "ICON_PACK",
                "EXPERIENCE_TYPE"
            ]
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_TYPOGRAPHY",
        "schema_type_version": 3,
        "filename": "theme.json",
        "filepointer": "/baseTokens/questionnaire/typography",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/typography",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "title": "Typography",
            "type": "object",
            "definitions": {
                "fontWeight": {
                    "type": "string",
                    "pattern": "[1-9]00$"
                },
                "pixelSize": {
                    "type": "string",
                    "pattern": "[0-9]+px"
                },
                "fontFamily": {
                    "type": "string",
                    "enum": [
                        "$questionnaire.typography.fontFamily.primary",
                        "$questionnaire.typography.fontFamily.secondary"
                    ]
                }
            },
            "properties": {
                "fontFamily": {
                    "type": "object",
                    "properties": {
                        "primary": {
                            "type": "string",
                            "default": "Poppins"
                        },
                        "secondary": {
                            "type": "string",
                            "default": "Poppins"
                        }
                    },
                    "required": [
                        "primary",
                        "secondary"
                    ]
                },
                "button": {
                    "type": "object",
                    "properties": {
                        "fontWeight": {
                            "$ref": "#/definitions/fontWeight"
                        },
                        "fontSize": {
                            "$ref": "#/definitions/pixelSize"
                        },
                        "fontFamily": {
                            "$ref": "#/definitions/fontFamily"
                        }
                    }
                },
                "body": {
                    "type": "object",
                    "properties": {
                        "fontFamily": {
                            "$ref": "#/definitions/fontFamily"
                        },
                        "desktop": {
                            "type": "object",
                            "properties": {
                                "fontWeight": {
                                    "$ref": "#/definitions/fontWeight"
                                },
                                "fontWeightBold": {
                                    "$ref": "#/definitions/fontWeight"
                                },
                                "fontWeightItalic": {
                                    "$ref": "#/definitions/fontWeight"
                                }
                            }
                        },
                        "l": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        }
                                    }
                                }
                            }
                        },
                        "m": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                "heading": {
                    "type": "object",
                    "properties": {
                        "xl": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        },
                        "l": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        },
                        "m": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        },
                        "s": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        },
                        "xs": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        },
                        "xxs": {
                            "type": "object",
                            "properties": {
                                "desktop": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                },
                                "mobile": {
                                    "type": "object",
                                    "properties": {
                                        "fontWeight": {
                                            "$ref": "#/definitions/fontWeight"
                                        },
                                        "fontSize": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "lineHeight": {
                                            "$ref": "#/definitions/pixelSize"
                                        },
                                        "fontFamily": {
                                            "$ref": "#/definitions/fontFamily"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            "required": [
                "fontFamily"
            ]
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_CONFIG",
        "schema_type_version": 8,
        "filename": "config.json",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/config",
            "$schema": "http://json-schema.org/draft-07/schema#",
            "title": "Config",
            "type": "object",
            "properties": {
                "EXPERIENCE_TYPE": {
                    "type": "string",
                    "enum": [
                        "cobrand",
                        "private-label",
                        "standard"
                    ],
                    "default": "standard"
                },
                "ICON_PACK": {
                    "type": "string",
                    "enum": [
                        "detailed",
                        "sharp",
                        "soft",
                        "custom",
                        "viu"
                    ],
                    "default": "viu"
                },
                "CTA_CASE": {
                    "type": "string",
                    "enum": [
                        "ALL_CAPS",
                        "TITLE_CASE",
                        "SENTENCE_CASE"
                    ]
                },
                "PHONE_MASK": {
                    "type": "string"
                },
                "PHONE_NUMBER": {
                    "type": "string"
                },
                "SUPPORTED_INSURANCE_LINES": {
                    "type": "object",
                    "properties": {
                        "CONDOMINIUM": {
                            "type": "boolean",
                            "default": true
                        },
                        "LANDLORD": {
                            "type": "boolean",
                            "default": true
                        },
                        "LIFE": {
                            "type": "boolean",
                            "default": false
                        },
                        "MOTORCYCLE": {
                            "type": "boolean",
                            "default": true
                        },
                        "PERSONAL_AUTO": {
                            "type": "boolean",
                            "default": true
                        },
                        "PERSONAL_HOME": {
                            "type": "boolean",
                            "default": true
                        },
                        "PET": {
                            "type": "boolean",
                            "default": false
                        },
                        "RENTERS": {
                            "type": "boolean",
                            "default": true
                        }
                    },
                    "default": {
                        "PERSONAL_AUTO": true,
                        "PERSONAL_HOME": true,
                        "RENTERS": true,
                        "LIFE": false,
                        "CONDOMINIUM": true,
                        "MOTORCYCLE": true,
                        "LANDLORD": true,
                        "PET": false
                    }
                },
                "ORDERED_INSURANCE_LINES": {
                    "type": "array",
                    "items": {
                        "type": "string",
                        "enum": [
                            "CONDOMINIUM",
                            "LANDLORD",
                            "LIFE",
                            "MOTORCYCLE",
                            "PERSONAL_AUTO",
                            "PERSONAL_HOME",
                            "PET",
                            "RENTERS"
                        ]
                    },
                    "default": [
                        "PERSONAL_AUTO",
                        "PERSONAL_HOME",
                        "RENTERS",
                        "LIFE",
                        "CONDOMINIUM",
                        "MOTORCYCLE",
                        "LANDLORD",
                        "PET"
                    ],
                    "uniqueItems": true
                }
            },
            "required": [
                "SUPPORTED_INSURANCE_LINES",
                "ORDERED_INSURANCE_LINES",
                "ICON_PACK",
                "EXPERIENCE_TYPE"
            ]
        }
    },
    {
        "schema_type": "QUOTE_EXPERIENCE_COLORS",
        "schema_type_version": 2,
        "filename": "theme.json",
        "filepointer": "/baseTokens/questionnaire/colors",
        "schema": {
            "$id": "https://viu-schema-data/schema/quote_experience/colors.json",
            "$schema": "https://json-schema.org/draft/2020-12/schema",
            "definitions": {
                "color": {
                    "type": "string",
                    "pattern": "^#(?:[0-9a-fA-F]{3}){1,2}$"
                }
            },
            "title": "Colors",
            "type": "object",
            "properties": {
                "informativeDark": {
                    "$ref": "#/definitions/color",
                    "default": "#001b57"
                },
                "informativeLight": {
                    "$ref": "#/definitions/color",
                    "default": "#e5eeff"
                },
                "informativeMedium": {
                    "$ref": "#/definitions/color",
                    "default": "#0049e5"
                },
                "negativeDark": {
                    "$ref": "#/definitions/color",
                    "default": "#70101d"
                },
                "negativeLight": {
                    "$ref": "#/definitions/color",
                    "default": "#fce9eb"
                },
                "negativeMedium": {
                    "$ref": "#/definitions/color",
                    "default": "#b21a2e"
                },
                "onPrimaryUi": {
                    "$ref": "#/definitions/color",
                    "default": "#ffffff"
                },
                "positiveDark": {
                    "$ref": "#/definitions/color",
                    "default": "#0f6628"
                },
                "positiveLight": {
                    "$ref": "#/definitions/color",
                    "default": "#e0fae7"
                },
                "positiveMedium": {
                    "$ref": "#/definitions/color",
                    "default": "#11732d"
                },
                "primaryAccent": {
                    "$ref": "#/definitions/color",
                    "default": "#0039b2"
                },
                "primaryBackground": {
                    "$ref": "#/definitions/color",
                    "default": "#FFFFFF"
                },
                "primaryBackgroundHover": {
                    "$ref": "#/definitions/color",
                    "default": "#d1e0ff"
                },
                "primaryBackgroundSelected": {
                    "$ref": "#/definitions/color",
                    "default": "#c2d5ff"
                },
                "primaryBorder": {
                    "$ref": "#/definitions/color",
                    "default": "#303336"
                },
                "primaryBorderHover": {
                    "$ref": "#/definitions/color",
                    "default": "#d1e0ff"
                },
                "primaryText": {
                    "$ref": "#/definitions/color",
                    "default": "#303336"
                },
                "primaryUi": {
                    "$ref": "#/definitions/color",
                    "default": "#0039b2"
                },
                "primaryUiBackgroundDisabled": {
                    "$ref": "#/definitions/color",
                    "default": "#b2cbff"
                },
                "primaryUiForegroundDisabled": {
                    "$ref": "#/definitions/color",
                    "default": "#e5eeff"
                },
                "primaryUiHover": {
                    "$ref": "#/definitions/color",
                    "default": "#003099"
                },
                "secondaryAccent": {
                    "$ref": "#/definitions/color",
                    "default": "#c91d34"
                },
                "secondaryBackground": {
                    "$ref": "#/definitions/color",
                    "default": "#f7f7f8"
                },
                "secondaryBorder": {
                    "$ref": "#/definitions/color",
                    "default": "#6d7278"
                },
                "secondaryText": {
                    "$ref": "#/definitions/color",
                    "default": "#000000"
                },
                "secondaryUi": {
                    "$ref": "#/definitions/color",
                    "default": "#001b57"
                },
                "tertiaryText": {
                    "$ref": "#/definitions/color",
                    "default": "#494c50"
                },
                "warningDark": {
                    "$ref": "#/definitions/color",
                    "default": "#59390d"
                },
                "warningLight": {
                    "$ref": "#/definitions/color",
                    "default": "#fcf6ed"
                },
                "warningMedium": {
                    "$ref": "#/definitions/color",
                    "default": "#935f15"
                }
            }
        }
    }
];